import request from './adminRequest'

export const auditingCourseApi = {
  listAuditingCourse (params) {
    return request.get('/auditingCourses', { params: params })
  },
  deleteAuditingCourse (id, params) {
    return request.delete('/auditingCourses/' + id, { params: params })
  },
  // 名企一对一审核
  getAuditingEnterpriseToOne (id, params) {
    return request.get('/auditingEnterpriseToOnes/' + id, { params: params })
  },
  processAuditingEnterpriseToOne  (id, data) {
    return request.put('/auditingEnterpriseToOnes/' + id, data)
  },
  // deleteAuditEnterpriseToOne (id, params) {
  //   return request.delete('/auditingEnterpriseToOnes/' + id, { params: params })
  // },
  // 在线实战项目审核
  getAuditingOnlineAction (id, params) {
    return request.get('/auditingOnlineActions/' + id, { params: params })
  },
  processAuditingOnlineAction (id, data) {
    return request.put('/auditingOnlineActions/' + id, data)
  },
  // deleteAuditingOnlineAction (id, params) {
  //   return request.delete('/auditingOnlineActions/' + id, { params: params })
  // },
  // 求职辅导审核
  getAuditingJobCounseling (id, params) {
    return request.get('/auditingJobCounselings/' + id, { params: params })
  },
  processAuditingJobCounseling (id, data) {
    return request.put('/auditingJobCounselings/' + id, data)
  },
  // deleteAuditingJobCounseling (id, params) {
  //   return request.delete('/auditingJobCounselings/' + id, { params: params })
  // },
  // 导师咨询审核
  listAuditingConsulting (params) {
    return request.get('/auditingConsultings', { params: params })
  },
  getAuditingConsulting (uid) {
    return request.get('/auditingConsultings/' + uid)
  },
  processAuditingConsulting (uid, data) {
    return request.put('/auditingConsultings/' + uid, data)
  },
  deleteAuditingConsulting (uid) {
    return request.delete('/auditingConsultings/' + uid)
  },
}
export default auditingCourseApi
